import React, { Component } from "react"
import { OverlayTrigger, Tooltip, Popover } from "react-bootstrap"
import { priceMulti } from "./vendor/cryptocompare"

export function formatPrice(
	rawQuote,
	rawPrice,
	isPremium = false,
	enablePriceConversion = true
) {
	if (rawPrice === null || rawPrice === undefined) {
		return <span>N/A</span>
	}
	const [quote, price] = roundPrice(rawQuote, rawPrice)
	if (isPremium) {
		return (
			<span>
				{enablePriceConversion ? (
					<OverlayTrigger
						trigger="click"
						rootClose
						placement="bottom"
						overlay={
							<Popover id="price-value" title={`${quote} ${price}`}>
								<PriceValue quote={quote} price={rawPrice} />
							</Popover>
						}
					>
						<a
							className="format-price"
							data-on="click"
							data-event-category="Price Value"
							data-event-action="click"
						>
							<PriceHelper quote={quote} price={price} />
						</a>
					</OverlayTrigger>
				) : (
					<PriceHelper quote={quote} price={price} />
				)}
			</span>
		)
	}
	if (rawPrice >= 1) {
		let result = ""
		let hidden = ""
		let significantDigits = 0
		for (const char of price) {
			if (significantDigits < 2) {
				if (char !== "," && char !== ".") {
					significantDigits++
				}
				result += char
			} else {
				if (char !== "," && char !== ".") {
					hidden += "0"
				} else {
					hidden += char
				}
			}
		}
		return (
			<span>
				{quote} <span className="price-leading">{result}</span>
				<UpgradeRequired content={hidden} />
			</span>
		)
	} else {
		let result = ""
		let hidden = ""
		let significantDigits = 0
		let isCounting = false
		let isHiding = false
		for (const char of price) {
			if (char !== "0" && char !== ".") {
				isCounting = true
			}
			if (isCounting) {
				significantDigits++
			}
			if (significantDigits > 2) {
				isHiding = true
			}
			if (!isHiding) {
				result += char
			} else {
				hidden += "0"
			}
		}
		return (
			<span>
				{quote} <span className="price-leading">{result}</span>
				<UpgradeRequired content={hidden} />
			</span>
		)
	}
}

function roundPrice(quote, price, useSat = false) {
	if (useSat && price < 1 && quote === "BTC") {
		return ["SAT", Math.round(price * 100000000).toLocaleString()]
	} else if (quote !== "BTC" && quote !== "ETH") {
		return [quote, Number(price.toFixed(2)).toLocaleString()]
	} else if (quote === "BTC" || quote === "ETH") {
		return [quote, price.toFixed(8)]
	} else {
		return [quote, price.toString()]
	}
}

export function formatGain(quote, marketValue, bookValue, isPremium = false) {
	if (bookValue === null) {
		return <span>N/A</span>
	}
	const gain = marketValue - bookValue
	if (gain < 0) {
		const value = Math.abs(gain)
		const gainValue = formatPrice(quote, value, isPremium)
		const gainPercent = (gain / bookValue * 100).toFixed(2)
		return (
			<span className="loss">
				({gainValue}) <span className="gain-percent">{gainPercent}%</span>
			</span>
		)
	} else {
		const gainValue = formatPrice(quote, gain, isPremium)
		const gainPercent = (gain / bookValue * 100).toFixed(2)
		return (
			<span className="gain">
				{gainValue} <span className="gain-percent">+{gainPercent}%</span>
			</span>
		)
	}
}

function UpgradeRequired({ content }) {
	return (
		<OverlayTrigger
			placement="bottom"
			overlay={
				<Tooltip id="upgrade-required">
					<span>Get Pro to display full precision.</span>
				</Tooltip>
			}
		>
			<span
				className="upgrade-required"
				data-on="click"
				data-event-category="Precision Upgrade Required"
				data-event-action="click"
			>
				{content}
			</span>
		</OverlayTrigger>
	)
}

function PriceHelper({ quote, price }) {
	if (Number.parseFloat(price) >= 1) {
		return (
			<span>
				{quote} <span className="price-leading">{price}</span>
			</span>
		)
	} else {
		let leading = ""
		let rest = ""
		let isCounting = false
		let count = 0
		for (const char of price) {
			if (char !== "0" && char !== ".") {
				isCounting = true
			}
			if (isCounting) {
				count++
			}
			if (count > 1) {
				rest += char
			} else {
				leading += char
			}
		}
		return (
			<span>
				{quote} <span className="price-leading">{leading}</span>
				<span className="price-rest">{rest}</span>
			</span>
		)
	}
}

const currencies = ["USD", "EUR", "BTC", "ETH", "SAT"]
const pricesPromise = priceMulti(currencies, currencies)

class PriceValue extends Component {
	constructor(props) {
		super(props)
		this.state = {
			usd: null,
			eur: null,
			btc: null,
			eth: null,
		}
	}

	componentDidMount() {
		this.calculatePrices()
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			this.props.quote !== prevProps.quote ||
			this.props.price !== prevProps.price
		) {
			this.calculatePrices()
		}
	}

	async calculatePrices() {
		let { quote, price } = this.props
		if (quote === "SAT") {
			quote = "BTC"
			price *= 0.00000001
		}
		const prices = await pricesPromise
		const conversion = prices[quote]
		if (conversion === undefined) {
			throw new Error(`No conversion for ${quote}`)
		}
		const [, usd] = roundPrice("USD", price * conversion.USD)
		const [, eur] = roundPrice("EUR", price * conversion.EUR)
		const [, btc] = roundPrice("BTC", price * conversion.BTC, false)
		const [, eth] = roundPrice("ETH", price * conversion.ETH)
		this.setState({
			usd: usd,
			eur: eur,
			btc: btc,
			eth: eth,
		})
	}

	render() {
		const { usd, eur, btc, eth } = this.state
		return (
			<div>
				<p>USD {usd}</p>
				<p>EUR {eur}</p>
				<p>BTC {btc}</p>
				<p>ETH {eth}</p>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/format.js